/* eslint-disable import/no-webpack-loader-syntax */
import icon from '!svg-inline-loader!./icons/apple.svg';
/* eslint-enable import/no-webpack-loader-syntax */

var apple = {
  name: 'apple',
  labels: {
    signIn: 'Sign in with Apple',
    signUp: 'Sign up with Apple'
  },
  icon: icon
};
export default apple;